function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module mention/mentioncommand
 */
import { Command } from 'ckeditor5/src/core';
import { CKEditorError, toMap } from 'ckeditor5/src/utils';
import { _addMentionAttributes } from './mentionediting';
/**
 * The mention command.
 *
 * The command is registered by {@link module:mention/mentionediting~MentionEditing} as `'mention'`.
 *
 * To insert a mention onto a range, execute the command and specify a mention object with a range to replace:
 *
 *		const focus = editor.model.document.selection.focus;
 *
 *		// It will replace one character before the selection focus with the '#1234' text
 *		// with the mention attribute filled with passed attributes.
 *		editor.execute( 'mention', {
 *			marker: '#',
 *			mention: {
 *				id: '#1234',
 *				name: 'Foo',
 *				title: 'Big Foo'
 *			},
 *			range: model.createRange( focus, focus.getShiftedBy( -1 ) )
 *		} );
 *
 *		// It will replace one character before the selection focus with the 'The "Big Foo"' text
 *		// with the mention attribute filled with passed attributes.
 *		editor.execute( 'mention', {
 *			marker: '#',
 *			mention: {
 *				id: '#1234',
 *				name: 'Foo',
 *				title: 'Big Foo'
 *			},
 *			text: 'The "Big Foo"',
 *			range: model.createRange( focus, focus.getShiftedBy( -1 ) )
 *		} );
 *
 * @extends module:core/command~Command
 */

var MentionCommand = /*#__PURE__*/function (_Command) {
  _inherits(MentionCommand, _Command);

  var _super = _createSuper(MentionCommand);

  function MentionCommand() {
    _classCallCheck(this, MentionCommand);

    return _super.apply(this, arguments);
  }

  _createClass(MentionCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var model = this.editor.model;
      var doc = model.document;
      this.isEnabled = model.schema.checkAttributeInSelection(doc.selection, 'mention');
    }
    /**
     * Executes the command.
     *
     * @param {Object} [options] Options for the executed command.
     * @param {Object|String} options.mention The mention object to insert. When a string is passed, it will be used to create a plain
     * object with the name attribute that equals the passed string.
     * @param {String} options.marker The marker character (e.g. `'@'`).
     * @param {String} [options.text] The text of the inserted mention. Defaults to the full mention string composed from `marker` and
     * `mention` string or `mention.id` if an object is passed.
     * @param {String} [options.range] The range to replace. Note that the replaced range might be shorter than the inserted text with the
     * mention attribute.
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute(options) {
      var model = this.editor.model;
      var document = model.document;
      var selection = document.selection;
      var mentionData = typeof options.mention == 'string' ? {
        id: options.mention
      } : options.mention;
      var mentionID = mentionData.id;
      var range = options.range || selection.getFirstRange();
      var mentionText = options.text || mentionID;

      var mention = _addMentionAttributes({
        _text: mentionText,
        id: mentionID
      }, mentionData);

      if (options.marker.length != 1) {
        /**
         * The marker must be a single character.
         *
         * Correct markers: `'@'`, `'#'`.
         *
         * Incorrect markers: `'$$'`, `'[@'`.
         *
         * See {@link module:mention/mention~MentionConfig}.
         *
         * @error mentioncommand-incorrect-marker
         */
        throw new CKEditorError('mentioncommand-incorrect-marker', this);
      }

      if (mentionID.charAt(0) != options.marker) {
        /**
         * The feed item ID must start with the marker character.
         *
         * Correct mention feed setting:
         *
         *		mentions: [
         *			{
         *				marker: '@',
         *				feed: [ '@Ann', '@Barney', ... ]
         *			}
         *		]
         *
         * Incorrect mention feed setting:
         *
         *		mentions: [
         *			{
         *				marker: '@',
         *				feed: [ 'Ann', 'Barney', ... ]
         *			}
         *		]
         *
         * See {@link module:mention/mention~MentionConfig}.
         *
         * @error mentioncommand-incorrect-id
         */
        throw new CKEditorError('mentioncommand-incorrect-id', this);
      }

      model.change(function (writer) {
        var currentAttributes = toMap(selection.getAttributes());
        var attributesWithMention = new Map(currentAttributes.entries());
        attributesWithMention.set('mention', mention); // Replace a range with the text with a mention.

        model.insertContent(writer.createText(mentionText, attributesWithMention), range);
        model.insertContent(writer.createText(' ', currentAttributes), range.start.getShiftedBy(mentionText.length));
      });
    }
  }]);

  return MentionCommand;
}(Command);

export { MentionCommand as default };